import { Box, Card, NumericMetric } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import BlankSlate from 'modules/insights/components/BlankSlate'
import type EmployeesAverageAge from 'modules/insights/lib/metrics/employeesAverageAge'

type Props = {
  employeesAverageAge: EmployeesAverageAge
}

const WidgetEmployeeAverageAge = ({ employeesAverageAge }: Props) => {
  const result = employeesAverageAge.generate()

  return (
    <Card>
      <Card.Title tooltip={i18n.t('insights.widgets.employee_average_age.tooltip')}>
        {i18n.t('insights.widgets.employee_average_age.title')}
      </Card.Title>
      <Card.Content>
        {employeesAverageAge.isEmpty() ? (
          <BlankSlate />
        ) : (
          <Box flexDirection="row" gap="s12" alignItems="center" height="full">
            <NumericMetric
              value={result}
              decimals={2}
              title={i18n.t('insights.widgets.employee_average_age.years')}
            />
          </Box>
        )}
      </Card.Content>
    </Card>
  )
}

export default WidgetEmployeeAverageAge
